import { EditorParamsApiKey } from '#packages/apis';
import * as stateManagement from '#packages/stateManagement';
import type { EditorAPI } from '@/editorAPI';
import { ErrorReporter } from '@wix/editor-error-reporter';
import { EditorPlatformHostIntegrationAPI } from '@wix/editor-platform-host-integration-apis';
import type { IntentInstallOptions } from '@wix/editor-platform-host-integration-apis';

const shouldRunIntentInstallInSilentMode = (editorAPI: EditorAPI) => {
  const isFirstSave =
    editorAPI.dsRead.generalInfo.isDraft() ||
    editorAPI.dsRead.generalInfo.isFirstSave();

  return isFirstSave;
};

async function platformIntentInstall(
  editorAPI: EditorAPI,
  options: IntentInstallOptions = {},
) {
  const platformAPI = editorAPI.host.getAPI(EditorPlatformHostIntegrationAPI);

  const editorParamsApi = editorAPI.host.getAPI(EditorParamsApiKey);

  const defaultShouldInstallPending =
    stateManagement.platform.selectors.shouldInstallPendingSilently(
      editorAPI,
    ) &&
    !editorParamsApi.siteCreationWizard &&
    !editorParamsApi.siteGenerationWizard;

  try {
    await platformAPI.applications.intentInstall?.({
      shouldInstallPending: defaultShouldInstallPending,
      isSilent: shouldRunIntentInstallInSilentMode(editorAPI),
      ...options,
    });
  } catch (e) {
    ErrorReporter.captureException(e, {
      tags: { intentInstallApps: true },
      extra: {
        options,
      },
    });
    throw e;
  }
}

export { platformIntentInstall };
